import {Component, OnInit} from '@angular/core';
import {AuthService} from "../../services/auth.service";
import {UsersService} from "../../services/users.service";
import {Notification} from "../../model/notification";
import {Constants} from "../../utils/constants";
import {MessageData} from "../../model/messageData";
import {SplitCamelCasePipe} from "../../pipes/split-camel-case.pipe";
import {EMPTY, Observable, of} from "rxjs";
import {switchMap, tap} from "rxjs/operators";
import {SnackService} from "../../services/snack.service";
import {hasPermission, User} from "../../model/user";


@Component({
  selector: 'aw-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit {

  notifications: Notification[] = [];
  lastNotification?: Notification;
  notificationsToDismiss: Notification[] = [];

  loading = false;
  loadingMore = false;
  noMoreNotifications = false;

  badgeNumber = 0;
  skipBatch = 0;

  allNotifications$!: Observable<any>;

  private loggedUser: User;

  constructor(private authService: AuthService,
              private usersService: UsersService,
              private snackService: SnackService,
              private splitCamelCase: SplitCamelCasePipe
  ) {
    this.loggedUser = this.authService.loggedUser();

  }

  ngOnInit(): void {
    this.allNotifications$ =
      of(true)
        .pipe(
          tap(() => this.loading = this.skipBatch === 0),
          switchMap(() =>
            this.usersService.getUserNotifications(this.skipBatch, this.loggedUser.id)),
          tap(notifications => {

            notifications.forEach(notification => {

              if (notifications.length < Constants.general.notificationsBatchSize)
                this.noMoreNotifications = true;

              if (!notification.isRead)
                this.badgeNumber++;

              this.notifications.push(notification);

              if (notifications.indexOf(notification) === (notifications.length - 1))
                this.lastNotification = notification;

            });


          }),
          tap(() => this.loading = false));

    this.allNotifications$.subscribe();
  }

  markAsRead(notifications: Notification[]): void {

    notifications.forEach(notification => {

      if (!notification.isRead) {

        notification.isRead = true;
        this.notificationsToDismiss.push(notification);
        this.badgeNumber--;
      }
    });

  }

  saveNotificationsMarkedAsRead(): void {

    if (this.notificationsToDismiss.length !== 0) {

      const ids = this.notificationsToDismiss.filter(value => value !== undefined).map(value => value.id);

      this.usersService.markNotificationsAsRead(this.loggedUser.id, {ids}).subscribe();

      // Done here and not in subscribe to avoid multiple equal http requests
      this.notificationsToDismiss = [];
    }

  }

  loadMoreNotifications(): void {
    this.loadingMore = true;
    this.skipBatch++;
    this.usersService.getUserNotifications(this.skipBatch, this.loggedUser.id)
      .pipe(switchMap(value => value ? this.allNotifications$ : EMPTY))
      .subscribe(
        () => {
          this.loadingMore = false;
        },
        (error) => {
          this.loadingMore = false;
          this.snackService.error(error.message);
        }, () => {
          this.loadingMore = false;
        });
  }

  // openNotificationsDialog() {
  //   this.dialog.open(NotificationsDialogComponent, {data: this.notifications})
  // }
}
